<template>
  <v-card >
      <v-card-title>
        {{title}}
      </v-card-title>
      <v-card-text>
        <v-checkbox
          v-model="vall"
          label="Tout sélectionner"
          hide-details
          @click="selectAll()"
        ></v-checkbox>
        <v-row>
        <v-col  v-for="el in data" v-bind:key="el[idprop]"
          cols="12"
          md="2"
        >
        <v-checkbox
          v-model="selected"
          :label="el[nameprop]"
          :value="el[idprop]"
          @change="update"
          hide-details
          ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    data: {
      type: Array
    },
    idprop: {
      type: String
    },
    nameprop: {
      type: String
    },
    name: {
      type: String
    }
  },
  data() {
    return {
      selected: [],
      all: false,
      vall: false
    };
  },
  methods: {
    selectAll() {
      this.all = !this.all;
      this.vall = this.all;
      this.selected = [];
      if (this.all) {
        for (let el in this.data) {
          this.selected.push(this.data[el][this.idprop]);
        }
      }
    },
    update() {
      this.all = this.selected.length == this.data.length;
      this.vall = this.all;
    }
  },
  watch: {
    selected: {
      handler: function() {
        let selection = [];
        for (let obj of this.selected) {
          if (obj) selection.push(obj);
        }
        this.$emit("newselection", { name: this.name, selected: selection });
      }
    },
    data: {
      handler: function() {
        this.selectAll();
      }
    }
  }
};
</script>
